import React from "react";

const CustomInput = ({ label, type, value, onChange, placeholder, error, name, className = "", onKeyDown, autoFocus, autoComplete }) => {
  const id = name || label?.toLowerCase().replace(/\W+/g, "-");
  return (
    <div>
      {label && (
        <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-slate-700">
          {label}
        </label>
      )}
      <input
        id={id}
        name={name}
        onKeyDown={onKeyDown}
        type={type}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        aria-invalid={!!error}
        className={`hf-input ${error ? "border-rose-400 focus:border-rose-500 focus:ring-rose-500/15" : ""} ${className}`}
        placeholder={placeholder}
      />
      {error && <p className="mt-1.5 text-xs text-rose-600">{error}</p>}
    </div>
  );
};

export default CustomInput;
